import styles from './ZoomHeader.module.css';
import logo from '../../images/questionpro-logo-nw.svg';

export const ZoomHeader = () => {
  const gotoHomePage = () => {
    window.location.href = '/meeting/apps/zoom/home';
  };

  return (
    <div className={styles.logoContainer}>
      <div>
        <span
          className={`wm-home ${styles.closeIcon}`}
          onClick={gotoHomePage}
          aria-label="zoom-home"
        />
      </div>
      <div className={styles.logoWrapper}>
        <img src={logo} alt="QuestionPro logo" className={styles.logo} />
      </div>
    </div>
  );
};
